import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import { StaticQuery, graphql } from 'gatsby'
import favicon from '../images/agile-docs.png'

import '../assets/scss/main.scss'

const storageAvailable = (type) => {
  try {
    var storage = window[type],
      x = '__storage_test__';
    storage.setItem(x, x);
    storage.removeItem(x);
    return true;
  }
  catch (e) {
    return false;
  }
}
const Layout = ({ children, location }) => {

  let content;
  if (location && location.pathname === '/') {
    content = (
      <div>
        {children}
      </div>
    )
  } else {
    content = (
      <div id="wrapper" className="page">
        <div>
          {children}
        </div>
      </div>
    )
  }

  if (storageAvailable('localStorage')) {
    window.location = 'https://marketplace.atlassian.com/apps/1220574/agile-docs-tree-view-for-jira?hosting=cloud&tab=overview';
  }

  return (
    <StaticQuery
      query={graphql`
        query siteTitleQueryAndSiteTitleQuery {
          site {
            siteMetadata {
              title
            }
          }
        }
      `}
      render={data => (
        <>
          <Helmet
            title={'Agile Docs'}
            meta={[
              { name: 'Agile Docs', content: 'Interact With Jira Like A Google Doc' },
            ]}
            link={[
              {
                rel: 'shortcut icon', type: 'image/png', href: `${favicon}`
              }
            ]}
          >
            <html lang="en" />
            <title>Agile Docs</title>
            <link rel="shortcut icon" href={favicon} />
            <meta property="og:image" content={favicon} />
            <meta name="google-site-verification" content="3DFxVzOViliRQlGKbRPSHnflAsPsK5G6ty-09YfW688" />
          </Helmet>
          {content}
        </>
      )}
    />
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
